export const Categories = [
    { checked: false, value: 'การเมือง' },
    { checked: false, value: 'การศึกษา' },
    { checked: false, value: 'ความรุนแรง' },
    { checked: false, value: 'ประวัติศาสตร์' },
    { checked: false, value: 'ม็อบ' },
    { checked: false, value: 'สังคมและวัฒนธรรม' },
    { checked: false, value: 'สื่อ' },
    { checked: false, value: 'สิทธิมนุษยชน' },
    { checked: false, value: 'การแพทย์' },
    { checked: false, value: 'ครอบครัว' },
    { checked: false, value: 'การเงิน' },
    { checked: false, value: 'โควิด-19' },
    { checked: false, value: 'สถาบันฯ' },
    { checked: false, value: 'เยาวชน' },
    { checked: false, value: 'ชีวิตประจำวัน' },
    { checked: false, value: 'สวัสดิการ' }
];